<template>
  <div>
    <b-modal id="permissionModal" title="Permission Error" v-model="permissionModal" centered ok-only>
      <p class="lead" style="font-weight: 400;">You are not permitted to perform this action.</p>
    </b-modal>
    <div>
      <b-alert
        :show="dismissCountDown"
        dismissible
        fade
        variant="warning"
        @dismiss-count-down="countDownChanged"
        v-model="showDismissibleAlert"
      >
      <p class="py-1 text-center">You have to select one or more table rows to create an invoice</p>
      </b-alert>
    </div>

    <b-card-code v-if="!error_loading"
      :title='$t(`message.payments`)'
      no-body
    >
      <b-card-body>
        <div class="d-flex justify-content-between flex-wrap">

          <!-- sorting  -->
          <b-form-group
            label="Sort"
            label-size="sm"
            label-align-sm="left"
            label-cols-sm="2"
            label-for="sortBySelect"
            class="mr-1 mb-md-0 align-items-center"
          >
            <b-input-group
              size="sm"
            >
              <b-form-select
                id="sortBySelect"
                v-model="sortBy"
                :options="sortOptions"
              >
                <template #first>
                  <option value="">
                    none
                  </option>
                </template>
              </b-form-select>
              <b-form-select
                v-model="sortDesc"
                size="sm"
                :disabled="!sortBy"
              >
                <option :value="false">
                  Asc
                </option>
                <option :value="true">
                  Desc
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>

          <!-- filter -->
          <b-form-group
            label="Filter"
            label-cols-sm="2"
            label-align-sm="left"
            label-size="sm"
            label-for="filterInput"
            class="mb-0 align-items-center"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Type to Search"
                debounce=500
              />
              <b-input-group-append>
                <b-button
                  :disabled="!filter"
                  @click="filter = ''"
                >
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-card-body>


    <b-card-code
      class="card_code_table"
      no-body
    >
      <b-skeleton-table
        v-if="isBusy"
        :rows="5"
        :columns="5"
        :table-props="{ bordered: true, striped: true }"
      ></b-skeleton-table>
      <b-table
        v-else
        ref="selectableTable"
        striped
        hover
        responsive
        class="position-relative"
        :per-page="perPage"
        :current-page="currentPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        :busy="isBusy"
        >
        <template #cell(check_tr)="data">
          <b-form-checkbox
          v-if="!data.item.valid_until"
          :id="'checkbox'+data.item.quote_id"
          :name="'checkbox'+data.item.quote_id"
          @change="getInvoiceData(data.item.quote_id, $event,  data.item)"
        >
        </b-form-checkbox>
          <b-form-checkbox
          v-else
          :id="'checkbox'+data.item.quote_id"
          :name="'checkbox'+data.item.quote_id"
          :disabled="true"
        >
        </b-form-checkbox>
        </template>
        <template #cell(invoice_tr)="data">
          <b-dropdown :id="'dropdown_'+data.item.quote_id" size="sm" text="Invoice" v-if="data.item.valid_until">
            <b-dropdown-item v-if="data.item.invoice_tr" :href="'https://www.vivapayments.com/web2?ref='+data.item.invoice_tr" target="_blank">Checkout</b-dropdown-item>
            <b-dropdown-item v-if="data.item.tr_token" :href="'https://quote.safetravel.today/invoice.php?t='+data.item.tr_token" target="_blank">Invoice</b-dropdown-item>
          </b-dropdown>
          <div v-else> - </div>
        </template>
      </b-table>

      <!-- buttons -->
      <b-card-body class="demo-inline-spacing pt-0" v-if="items.length">
        <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            @click="downloadExcel(items,'Payments.xlsx')"
          >
            {{$t('message.payments')}} Excel
        </b-button>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="outline-primary"
          @click="createInvoice()"
        >
          {{$t('message.create_invoice')}}
        </b-button>
        <div v-show="invoiceDropState">
          <b-dropdown id="dropdown-invoice" text="Invoice" class="m-md-2">
            <b-dropdown-item :href="checkoutLink" target="_blank">Checkout</b-dropdown-item>
            <b-dropdown-item :href="invoiceLink" target="_blank">Invoice</b-dropdown-item>
          </b-dropdown>
        </div>
      </b-card-body>

      <template #code>
        {{ codeRowSelectSupport }}
      </template>
    </b-card-code>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">

        <!-- page length -->
        <b-form-group
          label="Per Page"
          label-cols="6"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1 align-items-center"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
          />
        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0 align-items-center"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>

      <template #code>
        {{ codeKitchenSink }}
      </template>
    </b-card-code>
    <ErrorAlert 
      v-else
      :heading="$t('message.couldntloadpayments')"
      :message="$t('message.couldntloadpaymentsmsg')"
    />
  </div>
</template>

<script>
import ErrorAlert from '../pages/components/ErrorAlert.vue';
import { downloadExcelMixin } from '@/products';
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import moment from 'moment'
import {
  BTable, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BDropdown, BDropdownItem, BAlert, BFormCheckbox, BSkeletonTable, BModal
} from 'bootstrap-vue'
import { codeKitchenSink } from '../table/bs-table/code'
import Ripple from 'vue-ripple-directive'
import { codeRowSelectSupport } from '../table/bs-table/code'
import { performLogoutWithoutRedirect } from '@/auth/logout'

export default {
  mixins: [downloadExcelMixin],
  components: {
    ErrorAlert,
    BCardCode,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BDropdown,
    BDropdownItem,
    BAlert,
    BFormCheckbox,
    BSkeletonTable,
    BModal
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      error_loading: false,
      permissionModal: false,
      invoiceArr: [],
      isBusy: true,
      perPage: 5,
      pageOptions: [5, 10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: 'valid_until',
      sortDesc: true,
      sortDirection: 'desc',
      filter: null,
      filterOn: [],
      fields: [
        { key: 'check_tr', label: 'Check', sortable: true },
        { key: 'transaction_ids', label: 'Transaction Ids', sortable: true },
        { key: 'quote_id', label: 'Quote ID', sortable: true },
        { key: 'customer_name', label: 'Customer Name', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'sold_by', label: 'Sold By', sortable: true },
        { key: 'policy_type', label: 'Policy Type', sortable: true },
        { key: 'full_amount', label: 'Full Amount', sortable: true, tdClass: 'text-nowrap' },
        { key: 'invoice_tr', label: 'Invoice', sortable: true },
        { key: 'valid_until', label: 'Valid Until', sortable: true },
        { key: 'issued', label: 'Issued', sortable: true, tdClass: 'text-nowrap' },
      ],
      /* eslint-disable global-require */
      items: [],
      codeKitchenSink,
      codeRowSelectSupport,
      transaction_ids: [],
      trid: null,
      checkoutLink: null,
      invoiceLink: null,
      dismissSecs: 5,
      dismissCountDown: 5,
      showDismissibleAlert: false,
      invoiceDropState: false,
    }
  },
  computed: {
    cookie() {
      return window?.$cookies?.get("jwt") ?? null;
    },
    token_id() {
      return this.$store.state.app?.userData?.id ?? null
    },
    ls_scope() {
      return this.$store.state.app?.userData?.scope ?? ''
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  async created() {
    let current_month = new Date();
    current_month.setDate(current_month.getDate() + 1);
    const cutoff_date = new Date();
    cutoff_date.setMonth(cutoff_date.getMonth() - 12);
    let isFirst = true;
    while (current_month >= cutoff_date) {
      const start_date = new Date(current_month);
      const end_date = new Date(current_month);
      // Decrease months for start date
      start_date.setMonth(start_date.getMonth() - 1);
      start_date.setHours(0, 0, 0, 0);  // Ensure the date is set to the start of the day
      // Set end date to the current month
      end_date.setHours(23, 59, 59, 999);
      await this.get_payments(start_date.toISOString().split('T')[0], end_date.toISOString().split('T')[0], isFirst);
      isFirst = false;
      current_month.setMonth(current_month.getMonth() - 1);  // Decrease to the previous month
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0,0);
    },
    async get_payments(start_date, end_date, init = false) {
      const data = {
          token: this.token_id,
          jwt: this.cookie,
          start_date,
          end_date
      };
      const url= {
        prod: 'https://api-quote.safetravel.today/v2/app/get_payments'
      };
      try {
          await fetch(url.prod, {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
          })
          .then((response) => {
            if (!response.ok) throw new Error(`Failed to get payments: HTTP ${response.status}`);
            return response.json();
          })
          .then((res) => {
            if (res === 'not_valid') {
              performLogoutWithoutRedirect(this.$store)
              return;
            }
            if (res) {
                const uniqueTransactions = res.reduce((acc, current) => {
                    const existing = acc.find(tr => tr.tr_transactionID === current.tr_transactionID);
                    if (!existing) {
                        acc.push(current);
                    }
                    return acc;
                }, []);
                uniqueTransactions.forEach((r) => {
                    this.items.push({
                        transaction_ids: r?.tr_transactionID,
                        quote_id: r?.tr_quote_id,
                        email: r?.tr_email,
                        sold_by: r?.tr_sold_by,
                        issued: r?.tr_issued_at,
                        customer_name: r?.tr_customer_name,
                        policy_type: r?.tr_policyType,
                        full_amount: r?.tr_viva_amount,
                        valid_until: r?.expires,
                        invoice_tr: r?.tr_invoice,
                        tr_token: r?.tr_token,
                    });
                });
            }
          })
          .then(() => {
            this.isBusy = false;
            this.totalRows = this.items.length;
            this.sortBy = 'valid_until';
          });
      } catch (err) {
        if (init) this.error_loading = true;
        console.warn(err);
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    async createInvoice() {
      this.showDismissibleAlert=false
      const idsArr=[];
      const tridArr=[];
      this.invoiceArr.forEach(e=> {
        idsArr.push(Number(e.transaction_ids))
        tridArr.push(e.tr_token)
      })
      const trid = tridArr.sort().slice(-1).pop();
      const data = {
        token: this.token_id,
        env: 'production',
        transaction_ids: idsArr
      }
      if (this.ls_scope.includes('app.travel-insurance.payment')) {
        if (idsArr.length > 0 && tridArr.length > 0) {
          try {
              await fetch('https://api-quote.safetravel.today/v2/app/payment-order/generate', {
              method: 'post',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(data)
              })
              .then((response) => {
                if (!response.ok) throw new Error(`Failed to generate payment order: HTTP ${response.status}`);
                return response.json();
              })
              .then((res)=>{
              const checkoutUrl = res.payment_order.checkoutUrl.split('?ref=')[1];
              const amount = res.payment_order.paymentOrder.amount / 100;
              const tExpired = moment().add(3, 'hours').format("YYYY-MM-DD hh:mm:ss");
              this.invoiceArr.forEach(e=> {
                  e.invoice_tr=checkoutUrl
                  e.valid_until= tExpired
                  e.tr_token = trid
                  e.full_amount = amount
              })
              })
          } catch (err) {
              console.warn(err)
          }
        } else {
          this.showDismissibleAlert=true
          this.scrollToTop()
        }
      } else {
        this.permissionModal=true
      }
      // go to first page
      this.currentPage = 1
    },
    getInvoiceData(ch, elem , obj) {
      if (elem) {
        this.invoiceArr.push(obj);
      } else {
        this.invoiceArr = this.invoiceArr.filter(e => e.quote_id !== ch)
      }
    },
  },
}
</script>
<style scoped>
  ::v-deep .card-title {
    color: var(--foreground-color);
    font-size: 1.65rem;
  }
  ::v-deep .card_code_table .card-header {
    display: none !important;
  }
</style>